export default {
    cn: {
        alertIgnore: {
            refresh: '刷新',
            add:'添加',
            type:'类型',
            node_id:'帐号',
            operate:'操作',
            delete:'删除',
            cancel:'取消',
            submit:'提交',
            submitTips:'请正确输入!',
            deleteTips:'确定删除?',
            typeMap:{
                IB:'父代理',
                IB_SUB:'子代理',
                SL:'父销售',
                SL_SUB:'子销售',
                ALL:'全部类型'
            },
        }
    },
    hk: {
        alertIgnore: {
            refresh: '刷新',
            add:'添加',
            type:'類型',
            node_id:'帳號',
            operate:'操作',
            delete:'刪除',
            cancel:'取消',
            submit:'提交',
            submitTips:'請正確輸入!',
            deleteTips:'確定刪除?',
            typeMap:{
                IB:'父代理',
                IB_SUB:'子代理',
                SL:'父銷售',
                SL_SUB:'子銷售',
                ALL:'全部類型'
            },
        }
    },
    en: {
        alertIgnore: {
            refresh: 'Refresh',
            add:'Add',
            type:'Type',
            node_id:'Node_id',
            operate:'Operate',
            delete:'Delete',
            cancel:'Cancel',
            submit:'Submit',
            submitTips:'Please input correct information!',
            deleteTips:'Are you sure to delete it?',
            typeMap:{
                IB:'Parent IB',
                IB_SUB:'Sub IB',
                SL:'Parent Sales',
                SL_SUB:'Sub Sales',
                ALL:'All Type'
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/alertIgnore.js